import { IoAddCircle, IoClose } from 'react-icons/io5';
import { AdminTanque, Dot } from '../../styles/admin';
import { ModalDownloadApp } from '../../styles/modals';
import { apiJalles } from '../../services/api';
import { HomeContext } from '../../contexts/contexHome';
import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';
import { ImBin } from 'react-icons/im';
import { CiEdit } from 'react-icons/ci';
import { FiSearch } from 'react-icons/fi';
import imgTanque from '../../assets/icons/Novotanque.png';
import { AdminContext } from '../../contexts/contexAdmin';
import { FaAndroid, FaApple } from 'react-icons/fa';
import { useBodyScrollLock } from '../../hooks/useBodyScrollLock';

const MODOS_PAINEL = [
  { value: 0, label: 'Modo geral — nível e bombas' },
  { value: 1, label: 'Modo individual — controle por bomba' },
  { value: 2, label: 'Somente nível' },
  { value: 3, label: 'Somente bombas — sem nível' },
];

export const TanqueAdmin = () => {
  const { headerApi } = useContext(HomeContext);
  const {
    modalConfimation,
    setModalConfimation,
    setSalveTanqueInfo,
    modalCreatTanque,
    setModalCreatTanque,
    setModalBombaTaque,
  } = useContext(AdminContext);

  const [tanquesList, setTanquesList] = useState(null);
  const [editedTanques, SetEditedTanques] = useState({});
  const [downloadModalOpen, setDownloadModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  useBodyScrollLock(downloadModalOpen);

  const ListTanques = useCallback(async () => {
    try {
      const idUnidade = sessionStorage.getItem('connectionsUnitId');

      const response = await apiJalles.get(`tanque/LeituraTodos/${idUnidade}`, headerApi);
      setTanquesList(response.data);
    } catch (error) {
      console.log(error);
    }
  }, [headerApi]);

  const handleInputChange = (e, tanqueId, type) => {
    SetEditedTanques((prevEditedTanque) => ({
      ...prevEditedTanque,
      [tanqueId]: {
        ...prevEditedTanque[tanqueId],
        [type]: e,
      },
    }));
  };

  useEffect(() => {
    ListTanques();
  }, [ListTanques, modalCreatTanque]);

  useEffect(() => {
    const initialEditedPivos = {};
    if (tanquesList != null) {
      tanquesList.forEach((tanque) => {
        initialEditedPivos[tanque.id] = { ...tanque };
      });
      SetEditedTanques(initialEditedPivos);
    }
  }, [tanquesList]);

  useEffect(() => {
    if (!downloadModalOpen) return undefined;

    const closeOnEscape = (event) => {
      if (event.key === 'Escape') setDownloadModalOpen(false);
    };

    document.addEventListener('keydown', closeOnEscape);
    return () => {
      document.removeEventListener('keydown', closeOnEscape);
    };
  }, [downloadModalOpen]);

  const visibleTanques = useMemo(() => {
    const normalizedSearch = searchTerm.trim().toLocaleLowerCase('pt-BR');

    return [...(tanquesList || [])]
      .filter((tanque) => {
        if (!normalizedSearch) return true;

        return [tanque.nome_tanque, tanque.id, tanque.gtw_tanque]
          .filter((value) => value !== null && value !== undefined)
          .some((value) => String(value).toLocaleLowerCase('pt-BR').includes(normalizedSearch));
      })
      .sort((firstTank, secondTank) =>
        (firstTank.nome_tanque || '').localeCompare(secondTank.nome_tanque || '', 'pt-BR', {
          sensitivity: 'base',
          numeric: true,
        }),
      );
  }, [searchTerm, tanquesList]);

  return (
    <AdminTanque>
      {downloadModalOpen &&
        createPortal(
          <ModalDownloadApp onClick={() => setDownloadModalOpen(false)}>
            <section
              className="downloadDialog"
              role="dialog"
              aria-modal="true"
              aria-labelledby="download-app-title"
              onClick={(event) => event.stopPropagation()}
            >
              <div className="downloadHeader">
                <div>
                  <span className="eyebrow">Aplicativo de configuração</span>
                  <h2 id="download-app-title">Escolha seu celular</h2>
                  <p>Configure Tanques, GTW TX e GTW RX diretamente pelo aplicativo.</p>
                </div>
                <button
                  type="button"
                  className="closeDownload"
                  aria-label="Fechar"
                  onClick={() => setDownloadModalOpen(false)}
                >
                  <IoClose />
                </button>
              </div>

              <div className="platformList">
                <a
                  className="platformOption androidOption"
                  href={`${process.env.PUBLIC_URL}/downloads/jalles-configurador.apk`}
                  download="Jalles-Configurador.apk"
                >
                  <span className="platformIcon">
                    <FaAndroid />
                  </span>
                  <span className="platformText">
                    <strong>Android</strong>
                    <small>Baixar instalador APK</small>
                  </span>
                  <span className="optionStatus">Baixar</span>
                </a>

                <button type="button" className="platformOption iosOption" disabled>
                  <span className="platformIcon">
                    <FaApple />
                  </span>
                  <span className="platformText">
                    <strong>iPhone</strong>
                    <small>Aplicativo para iOS</small>
                  </span>
                  <span className="optionStatus">Em breve</span>
                </button>
              </div>

              <p className="downloadNotice">
                No Android, talvez seja necessário permitir a instalação de aplicativos externos.
              </p>
            </section>
          </ModalDownloadApp>,
          document.body,
        )}
      <div className="Header">
        <h2>Tanques</h2>
        <div className="headerActions">
          <div className="addIcon">
            <div className="icons" onClick={() => setModalCreatTanque(true)}>
              <img src={imgTanque} alt="" />
              <IoAddCircle className="ADDIcon" />
            </div>
            <span>Criar Um Novo Tanque</span>
          </div>
          <button
            type="button"
            className="downloadApp"
            title="Baixar aplicativo para configurar Tanque e GTW"
            aria-haspopup="dialog"
            onClick={() => setDownloadModalOpen(true)}
          >
            <FaAndroid />
            <span>Baixar app de configuração</span>
          </button>
        </div>
      </div>

      <div className="tankSearchBar">
        <label>
          <FiSearch aria-hidden="true" />
          <input
            type="search"
            value={searchTerm}
            onChange={(event) => setSearchTerm(event.target.value)}
            placeholder="Buscar tanque por nome, ID ou gateway"
            aria-label="Buscar tanques"
          />
        </label>
        <span>
          {visibleTanques.length} {visibleTanques.length === 1 ? 'tanque encontrado' : 'tanques encontrados'}
        </span>
      </div>

      {tanquesList && visibleTanques.length === 0 ? (
        <div className="emptyTanks">
          <strong>Nenhum tanque encontrado</strong>
          <span>Altere o texto da busca para visualizar outros tanques.</span>
        </div>
      ) : (
        <ul>
          {visibleTanques.map((tanque) => {
              const cancelChanges = () => {
                SetEditedTanques((prevEditedTanques) => ({
                  ...prevEditedTanques,
                  [tanque.id]: {
                    ...prevEditedTanques[tanque.id],
                    nome_tanque: tanque.nome_tanque,
                    longitude: tanque.longitude,
                    latitude: tanque.latitude,
                    nivel_maximo: tanque.nivel_maximo,
                    nivel_minimo: tanque.nivel_minimo,
                    gtw_tanque: tanque.gtw_tanque,
                    painel: tanque.painel,
                    ativo: tanque.ativo,
                  },
                }));
              };

              const checkChangesTanque =
                JSON.stringify(tanque) === JSON.stringify(editedTanques[tanque.id]);

              return (
                <li key={tanque.id}>
                  <div className="headerTanqueInfo">
                    <input
                      type="text"
                      id={`${tanque.id}name`}
                      value={editedTanques[tanque.id]?.nome_tanque || ''}
                      onChange={(e) => handleInputChange(e.target.value, tanque.id, 'nome_tanque')}
                    />
                    <label htmlFor={`${tanque.id}name`}>
                      <CiEdit />
                    </label>
                    <ImBin
                      className="iconBin"
                      // onClick={() => {
                      //   setModalPivoDeletConfirmation(!modalPivoDeletConfirmation);
                      //   setSavePivoId(pivo.id);
                      // }}
                    />
                  </div>
                  <div className="infosPivo">
                    <label htmlFor={`${tanque.id}ID`}>ID da Tanque</label>
                    <input
                      type="number"
                      id={`${tanque.id}ID`}
                      value={editedTanques[tanque.id]?.id}
                      disabled={true}
                    />
                  </div>
                  <div className="infosPivo">
                    <label htmlFor={`${tanque.id}altura`}>Nível Máximo</label>
                    <input
                      type="number"
                      id={`${tanque.id}altura`}
                      value={editedTanques[tanque.id]?.nivel_maximo}
                      onChange={(e) => handleInputChange(e.target.value, tanque.id, 'nivel_maximo')}
                    />
                  </div>
                  <div className="infosPivo">
                    <label htmlFor={`${tanque.id}alturaMin`}>Nível Mínimo</label>
                    <input
                      type="number"
                      id={`${tanque.id}alturaMin`}
                      value={editedTanques[tanque.id]?.nivel_minimo}
                      onChange={(e) => handleInputChange(e.target.value, tanque.id, 'nivel_minimo')}
                    />
                  </div>

                  <div className="infosPivo">
                    <label htmlFor={`${tanque.id}latitude`}>Latitude</label>
                    <input
                      type="number"
                      id={`${tanque.id}latitude`}
                      value={editedTanques[tanque.id]?.latitude}
                      onChange={(e) => handleInputChange(e.target.value, tanque.id, 'latitude')}
                    />
                  </div>
                  <div className="infosPivo">
                    <label htmlFor={`${tanque.id}longitude`}>Longitude</label>
                    <input
                      type="number"
                      id={`${tanque.id}longitude`}
                      value={editedTanques[tanque.id]?.longitude}
                      onChange={(e) => handleInputChange(e.target.value, tanque.id, 'longitude')}
                    />
                  </div>
                  <div className="infosPivo">
                    <label htmlFor={`${tanque.id}QdtBombas`}>Quantidades de bombas</label>
                    <input
                      type="number"
                      id={`${tanque.id}QdtBombas`}
                      value={tanque.bombas.length || 0}
                      disabled={true}
                    />
                  </div>
                  <div className="infosPivo">
                    <label htmlFor={`${tanque.id}gtwTanque`}>Gateway LoRa (ID)</label>
                    <input
                      type="number"
                      min="0"
                      step="1"
                      id={`${tanque.id}gtwTanque`}
                      value={editedTanques[tanque.id]?.gtw_tanque ?? ''}
                      placeholder="Sem gateway"
                      onChange={(e) =>
                        handleInputChange(
                          e.target.value === '' ? null : Number(e.target.value),
                          tanque.id,
                          'gtw_tanque',
                        )
                      }
                    />
                  </div>
                  <div className="infosPivo">
                    <label htmlFor={`${tanque.id}painel`}>Modo do painel</label>
                    <select
                      id={`${tanque.id}painel`}
                      value={editedTanques[tanque.id]?.painel ?? 0}
                      onChange={(e) =>
                        handleInputChange(Number(e.target.value), tanque.id, 'painel')
                      }
                    >
                      {MODOS_PAINEL.map((modo) => (
                        <option key={modo.value} value={modo.value}>
                          {modo.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="infosPivo statusInfo">
                    <p>Status do Tanque</p>
                    <div className="selectBomb">
                      <span className="select">Ativado</span>
                      <button
                        onClick={() =>
                          handleInputChange(!editedTanques[tanque.id]?.ativo, tanque.id, 'ativo')
                        }
                      >
                        <Dot isLeft={editedTanques[tanque.id]?.ativo} />
                      </button>
                      <span className="select">Desativado</span>
                    </div>
                  </div>
                  <div className="buttons ">
                    <button
                      className="bombsSelect"
                      onClick={() => {
                        setModalBombaTaque(true);
                        setSalveTanqueInfo([tanque.id, editedTanques[tanque.id]]);
                      }}
                    >
                      Bombas
                    </button>
                  </div>
                  <div className="buttons">
                    <button
                      className={checkChangesTanque ? 'off' : ''}
                      disabled={checkChangesTanque}
                      onClick={() => {
                        setModalConfimation(!modalConfimation);
                        setSalveTanqueInfo([tanque.id, editedTanques[tanque.id]]);
                      }}
                    >
                      Salvar
                    </button>
                    <button disabled={checkChangesTanque} onClick={() => cancelChanges()}>
                      Cancelar
                    </button>
                  </div>
                </li>
              );
            })}
        </ul>
      )}
    </AdminTanque>
  );
};
